import TodoItem from "../todo-item/todo-item"
import DatetimeUtils from "../../../gd/utils/datetime-utils";
import {TodoListAccess} from "../@type";
import ModelEntity from "../../model-entity";
import {EntityType} from "../../../gd/const/item";
import TaskView_MessagesHelper from "../../../../item-view/task/manager/messages-helper";
import TodoItem_Collection from "../todo-item/collection";
import {generateULID} from "../../../gd/utils/id/ulid";

const debug = false
// const debug = "TodoList"

// Single To do list (!!)
// this is used in task view

export default class TodoList extends ModelEntity {

    // public manager            : any // ???

    public uid                  : ID

    public title                : string
    public momentCreated        : Moment
    public createdByUserId      : ID|null

    public access               : TodoListAccess

    public items                : TodoItem_Collection

    // constructor(manager:any, serializedTodoList: any) {
    constructor(serializedTodoList: any, access?: TodoListAccess) {

        super(serializedTodoList['uid'], EntityType.DYNAMIC_MODEL)

        // debug && console.log(debug, "constructor", manager, serializedTodoList)
        // this.manager            = manager
        this.uid                = serializedTodoList.uid
        this.title              = _.get(serializedTodoList,'title','Todo List')
        this.momentCreated      = DatetimeUtils.datetimeToMoment(_.get(serializedTodoList,'momentCreated',null))
        this.createdByUserId    = _.get(serializedTodoList,'createdByUserId',null)

        // init access

        this.access             = !!access ? access : {
            add     : false,
            edit    : this.createdByUserId === gd.session.me.id
        }

        // this.access = {
        //     add : !this.manager || this.manager.access.add,
        //     edit: !this.manager || this.manager.access.edit || this.createdByUserId === gd.session.me.id
        // }

        const todoListItems = _.chain(
            _.get(serializedTodoList,'items',[])).compact().map(item=>TodoItem.create(this, item)
        ).value()

        this.items              = new TodoItem_Collection(todoListItems)

    }

    get ids() {
        return this.items?.ids
    }

    public generateId():ID {

        // We ned new (!) cause now we use it as public id i.e. my work
        return generateULID()

        // OLD
        // return gd.utils.generateUIDWithCollisionChecking(this.ids)
    }

    static create(manager:any, data:any) {
        data.momentCreated      = moment()
        data.createdByUserId    = gd.session.me.id

        return new TodoList(data, manager.access)
    }

    setTitle(value:string) {
        if (value === '') value = "Todo List"
        this.title = value
    }

    getItem = (uid:ID) => {
        return _.find(this.items.models,['uid', uid])
    }

    getItemByMessageId = (messageId:ID) => {
        // @ts-ignore
        return _.find(this.items.models, item => item.properties.messageId === messageId)
    }

    addItem(item:TodoItem) {
        this.items.add(item)
    }

    deleteItem(uid:ID) {
        _.remove(this.items.models, item=>item.uid === uid)
    }

    pushItemAt(newItem:TodoItem, targetUid:ID, type:string='') {
        //remove no items at index and add newItem at this position
        const uidArray = _.map(this.items.models, item=>item.uid);
        const index = _.indexOf(uidArray, targetUid);
        switch (type) {
            case 'below':
                this.items.models.splice(index+1,0,newItem);
                break
            case 'above':
            default     :
                this.items.models.splice(index,0,newItem);
                break
        }
    }

    replaceItem(newItem:TodoItem, targetUid:ID) {
        this.pushItemAt(newItem, targetUid)
        this.deleteItem(targetUid)
    }

    getItems = (ignoreCompleted?: boolean) => {
        return ignoreCompleted ? _.filter(this.items.models, item => !item.isCompleted) : this.items.models
    }

    getCounters = () => ({
        total       : this.items.length,
        completed   : _.filter(this.items.models, item => item.isCompleted).length
    })

    messageHasInList(messageId: ID) {
        return _.find(this.items.models, (item: TodoItem)=>item.properties.messageId === messageId)
    }

    get length() {
        return this.items.length
    }

    get completedItemsLength() {
        return _.filter(this.items.models, item => item.isCompleted).length
    }

    get uncompletedItemsTotal() {
        return _.filter(this.items.models, item => !item.isCompleted).length
    }

    toText = (messagesManager?: TaskView_MessagesHelper)=> {
        let res = ''
        _.map(this.items.models, (item: TodoItem)=> {
            res += item.toText(messagesManager) + '\n'

            // @ts-ignore
            if (!!item.properties?.description && item.properties?.description.length > 0) {
                // @ts-ignore
                res += '\n' + item.properties.description + '\n\n'
            }

        })
        return res
    }

    onCopy  = () => {
        // gd.utils.copyToClipboard(this.props.list.toText(this.props.app?.messagesManager)) // Need messagesManager for task message !!!!
        gd.utils.copyToClipboard(this.toText())
        gd.growl.success("Todo list is copied to clipboard as text")
    }

    onSaveAsTemplate = () => {
        gd.session.todoListTemplates //required to ensure templates are loaded in session

        gd.modals.oneInput('Name', this.title, 'New ToDo template', (name) => {
            const todoList = this.getItems().map((todo: TodoItem)=>todo.getName())
            const request = gd.api.Company.TodoListTemplate.create(gd.companyId, name, todoList)
            request.done(()=>{
                gd.growl.success("Template saved.")
                gd.modal.hide()
            });
        })
    }

    toJSON(): JSONObject {
        return {
            uid             : this.uid,
            title           : this.title,
            momentCreated   : this.momentCreated?.toJSON() || null,
            createdByUserId : this.createdByUserId,
            items           : this.items.toJSON()
        }
    }
}
